<template>
  <div class="app-container">
    <el-tabs type="border-card" @tab-click="clickTab">
      <el-tab-pane label="易患评估">
        <component :is="currentView1" v-if="update"></component>
      </el-tab-pane>
      <el-tab-pane label="易患统计">
        <component :is="currentView2" v-if="update"></component>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import patientAssessment from "./patientAssessment";
import assessmentStatistics from "./assessmentStatistics";

export default {
  components: { patientAssessment, assessmentStatistics },
  data() {
    return {
      currentView1: "patientAssessment",
      currentView2: "assessmentStatistics",
      update: true
    };
  },
  created() {

  },
  methods: {
    clickTab(target) {
      console.log(target);
      if (target.index == "1") {
        //统计
      }
    }
  }
};
</script>

<style></style>
